import axios from "../axios-auth";

export const shopService = {
  getAllShop,
  getShopList,
  getShopById,
  saveShop,
};
function getShopList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }
  let url = "/auth/all-shop?page=" + page + "&size=" + size + "&sort=" + sortedBy;
  if (searchParams.name) {
    url += "&name=" + searchParams.name;
  }
  if (searchParams.code) {
    url += "&code=" + searchParams.code;
  }
  if (searchParams.warehouseId) {
    url += "&warehouseId=" + searchParams.warehouseId;
  }
  if (searchParams.shopId) {
    url += "&shopId=" + searchParams.shopId;
  }
  return axios.get(url);
}
function getAllShop() {
  return axios.get("auth/shops");
}

function getShopById(id) {
  return axios.get("auth/shop/" + id);
}

function saveShop(shop) {
  if (!shop.id) {
    //new shop
    return axios.post("/auth/shop", shop);
  } else {
    //edit
    return axios.put("/auth/shop", shop);
  }
}
